import type {
  FilterParams,
  RatingCategory,
} from '@/modules/common/context/QueryParams/models';
import type {FilterParams as GtmFilterParams} from '@/redux/middleware/googleTagManager/types';

import {formatMinutesAsTime} from '@/utils/date';
import {
  groupHotelAttributeTypes,
  isSpecialGroupFlexType,
  isSpecialGroupPromotionType,
  isSpecialGroupSafetyType,
} from '@/utils/inviaType';

export const serializeFilterRating = (
  filterRating?: null | RatingCategory
): string => {
  if (!filterRating) {
    return '';
  }

  return filterRating.replace(/_\w/, function (m) {
    return m[1].toUpperCase();
  });
};

export const mapFilterParamsToGTMEvent = (
  filterParams: FilterParams
): GtmFilterParams => {
  const hotelAttributeFilters = groupHotelAttributeTypes(
    filterParams.hotelAttributes || []
  );

  return {
    search_board: filterParams.boardTypes
      ? filterParams.boardTypes.join(',')
      : '',
    search_room: filterParams.roomTypes ? filterParams.roomTypes.join(',') : '',
    search_hotel_category:
      filterParams.categoryMin == null ? '' : String(filterParams.categoryMin),
    search_user_rating: serializeFilterRating(filterParams.ratingMin),
    search_duration: filterParams.duration || '',
    search_pool: hotelAttributeFilters.pool.join(','),
    search_beach: hotelAttributeFilters.beach.join(','),
    search_wellness: hotelAttributeFilters.wellness.join(','),
    search_children_offers: hotelAttributeFilters.children.join(','),
    search_entertainment: hotelAttributeFilters.animation.join(','),
    search_sport: hotelAttributeFilters.sports.join(','),
    search_watersport: hotelAttributeFilters.waterSports.join(','),
    search_restaurant: hotelAttributeFilters.restaurants.join(','),
    search_hotel_facilities: hotelAttributeFilters.hotel.join(','),
    search_hotel_type: hotelAttributeFilters.type.join(','),
    search_price_max:
      filterParams.priceMax == null ? '' : filterParams.priceMax.amount,
    search_price_min:
      filterParams.priceMin == null ? '' : filterParams.priceMin.amount,
    search_seaview: filterParams.roomViews
      ? filterParams.roomViews.join(',')
      : '',
    search_room_attributes: filterParams.roomAttributes
      ? filterParams.roomAttributes.join(',')
      : '',
    search_sustainability: hotelAttributeFilters.sustainability.join(','),
    search_organizer: (filterParams.tourOperators || []).join(','),
    search_arrival_departure_time_min:
      filterParams.returnTimeMin == null
        ? ''
        : formatMinutesAsTime(filterParams.returnTimeMin),
    search_arrival_departure_time_max:
      filterParams.returnTimeMax == null
        ? ''
        : formatMinutesAsTime(filterParams.returnTimeMax),
    search_departure_departure_time_min:
      filterParams.departureTimeMin == null
        ? ''
        : formatMinutesAsTime(filterParams.departureTimeMin),
    search_departure_departure_time_max:
      filterParams.departureTimeMax == null
        ? ''
        : formatMinutesAsTime(filterParams.departureTimeMax),
    search_transfer: filterParams.transportations
      ? filterParams.transportations.join(',')
      : '',
    search_organizer_promotion:
      filterParams?.specials
        ?.filter((filter) => {
          return isSpecialGroupPromotionType(filter);
        })
        .join(',') || '',
    search_flex_option:
      filterParams?.specials
        ?.filter((filter) => {
          return isSpecialGroupFlexType(filter);
        })
        .join(',') || '',
    search_safety_option:
      filterParams?.specials
        ?.filter((filter) => {
          return isSpecialGroupSafetyType(filter);
        })
        .join(',') || '',
    search_airlines: filterParams.airlines
      ? filterParams.airlines.join(',')
      : '',
    search_destination_airports: filterParams.arrivalAirports
      ? filterParams.arrivalAirports.join(',')
      : '',
    search_distance_airport: filterParams.distanceAirportMax || '',
    search_distance_beach: filterParams.distanceBeachMax || '',
    search_distance_city_center: filterParams.distanceCityCenterMax || '',
    search_distance_ski_slope: filterParams.distanceSkiSlopeMax || '',
  };
};
